"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementsStore = void 0;
const mobx_1 = require("mobx");
const statements_1 = require("@App/api/routes/rightsholder/statements");
const handle_aborted_exception_1 = require("@App/helpers/handle-aborted-exception");
const dayjs_1 = __importDefault(require("dayjs"));
class StatementsStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_dspRates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_ratePeriods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_rateDsps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_royalties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_latestRoyaltiesDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_payeeOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_statements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "_selectedPayee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_selectedUsagePeriod", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_selectedDsp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_downloadData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "_distributionSummaryPdfLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadDspRates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (year, month, dsp) => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, statements_1.getDspRates)(year, month, dsp);
                (0, mobx_1.runInAction)(() => (this._dspRates = response.data));
            })
        });
        Object.defineProperty(this, "loadRoyalties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (year, month, signal) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield (0, statements_1.getRoyalties)(this.rootStore.rightsholderStore.currentRightsholderId, year, month, signal);
                    (0, mobx_1.runInAction)(() => (this._royalties = response.data.sort((a, b) => (a.payeeName < b.payeeName ? -1 : 1))));
                }
                catch (e) {
                    (0, handle_aborted_exception_1.handleAbortedException)(e);
                }
            })
        });
        Object.defineProperty(this, "loadRateSheetPeriods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, statements_1.getRatePeriods)();
                (0, mobx_1.runInAction)(() => (this._ratePeriods = response.data));
            })
        });
        Object.defineProperty(this, "loadRateSheetDsps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, statements_1.getRateDsps)();
                (0, mobx_1.runInAction)(() => (this._rateDsps = response.data));
            })
        });
        Object.defineProperty(this, "loadLatestRoyaltiesDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, statements_1.getLatestRoyaltiesDate)(this.rootStore.rightsholderStore.currentRightsholderId);
                (0, mobx_1.runInAction)(() => (this._latestRoyaltiesDate = response.data));
            })
        });
        Object.defineProperty(this, "loadPayeeOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, statements_1.getPayeeOptions)(this.rootStore.rightsholderStore.currentRightsholderId);
                (0, mobx_1.runInAction)(() => (this._payeeOptions = response.data));
            })
        });
        Object.defineProperty(this, "loadStatements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (payee) => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, statements_1.getStatements)(this.rootStore.rightsholderStore.currentRightsholderId, payee);
                (0, mobx_1.runInAction)(() => (this._statements = response.data));
            })
        });
        Object.defineProperty(this, "loadDistributionSummaryPdfLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (year, month) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield (0, statements_1.getDistributionSummaryLink)(this.rootStore.rightsholderStore.currentRightsholderId, year, month);
                    (0, mobx_1.runInAction)(() => (this._distributionSummaryPdfLink = response.data.downloadLink));
                }
                catch (ignore) {
                    (0, mobx_1.runInAction)(() => (this._distributionSummaryPdfLink = null));
                }
            })
        });
        Object.defineProperty(this, "clearRoyalties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._royalties = null;
                this._distributionSummaryPdfLink = null;
            }
        });
        Object.defineProperty(this, "clearDspRates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._dspRates = null;
            }
        });
        Object.defineProperty(this, "clearStatements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._statements = [];
            }
        });
        Object.defineProperty(this, "clearFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._selectedUsagePeriod = { id: '', label: '', value: '' };
                this._selectedPayee = { id: '', label: '', value: '' };
                this._selectedDsp = { id: '', label: '', value: '' };
                this._latestRoyaltiesDate = undefined;
                this._payeeOptions = undefined;
            }
        });
        Object.defineProperty(this, "setSelectedPayee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (selectedPayee) => {
                this._selectedPayee = selectedPayee;
            }
        });
        Object.defineProperty(this, "setSelectedUsagePeriod", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (selectedUsagePeriod) => {
                this._selectedUsagePeriod = selectedUsagePeriod;
            }
        });
        Object.defineProperty(this, "setSelectedDsp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (selectedDsp) => {
                this._selectedDsp = selectedDsp;
            }
        });
        Object.defineProperty(this, "addItemToDownloadData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                this._downloadData.push(id);
            }
        });
        Object.defineProperty(this, "removeItemFromDownloadData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const index = this._downloadData.indexOf(id);
                if (index > -1) {
                    this._downloadData.splice(index, 1);
                }
            }
        });
        Object.defineProperty(this, "resetDownloadData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._downloadData = [];
            }
        });
        Object.defineProperty(this, "setUsagePeriod", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this._selectedUsagePeriod = value;
                this._downloadData = [];
            }
        });
        Object.defineProperty(this, "setDsp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this._selectedDsp = value;
                this._downloadData = [];
            }
        });
        Object.defineProperty(this, "selectAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._downloadData = this.filteredRows.slice().map((row) => row.id);
            }
        });
        Object.defineProperty(this, "deselectAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this._downloadData = [];
            }
        });
        (0, mobx_1.makeObservable)(this, {
            _dspRates: mobx_1.observable,
            _ratePeriods: mobx_1.observable,
            _rateDsps: mobx_1.observable,
            _royalties: mobx_1.observable,
            _latestRoyaltiesDate: mobx_1.observable,
            _payeeOptions: mobx_1.observable,
            _statements: mobx_1.observable,
            _selectedPayee: mobx_1.observable,
            _selectedUsagePeriod: mobx_1.observable,
            _selectedDsp: mobx_1.observable,
            _downloadData: mobx_1.observable,
            _distributionSummaryPdfLink: mobx_1.observable,
            clearRoyalties: mobx_1.action,
            clearDspRates: mobx_1.action,
            clearStatements: mobx_1.action,
            clearFilters: mobx_1.action,
            royaltiesUsagePeriodOptions: mobx_1.computed,
            rateSheetUsagePeriodOptions: mobx_1.computed,
            rateSheetDspOptions: mobx_1.computed,
            payeeOptionsForSelect: mobx_1.computed,
            dspOptions: mobx_1.computed,
            filteredRows: mobx_1.computed,
            setSelectedPayee: mobx_1.action,
            setSelectedUsagePeriod: mobx_1.action,
            setSelectedDsp: mobx_1.action,
            addItemToDownloadData: mobx_1.action,
            setUsagePeriod: mobx_1.action,
            setDsp: mobx_1.action,
            selectAll: mobx_1.action,
            deselectAll: mobx_1.action,
            loadPayeeOptions: mobx_1.action,
            removeItemFromDownloadData: mobx_1.action,
            resetDownloadData: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    get dspRates() {
        return this._dspRates;
    }
    get ratePeriods() {
        return this._ratePeriods;
    }
    get rateDsps() {
        return this._rateDsps;
    }
    get royalties() {
        return this._royalties;
    }
    get latestRoyaltiesDate() {
        return this._latestRoyaltiesDate;
    }
    get payeeOptions() {
        return this._payeeOptions;
    }
    get statements() {
        return this._statements;
    }
    get selectedUsagePeriod() {
        return this._selectedUsagePeriod;
    }
    get selectedPayee() {
        return this._selectedPayee;
    }
    get selectedDsp() {
        return this._selectedDsp;
    }
    get downloadData() {
        return this._downloadData;
    }
    get distributionSummaryPdfLink() {
        return this._distributionSummaryPdfLink;
    }
    get rateSheetUsagePeriodOptions() {
        var _a;
        return this._ratePeriods
            ? (_a = this._ratePeriods) === null || _a === void 0 ? void 0 : _a.map((period, idx) => ({
                label: period.periodName,
                value: period.period,
                id: idx.toString(),
            }))
            : [];
    }
    get rateSheetDspOptions() {
        return this._rateDsps
            ? [
                { label: 'All', value: 'All', id: 'all' },
                ...this._rateDsps
                    .map((dsp, idx) => ({
                    label: dsp.dspName,
                    value: dsp.name,
                    id: idx.toString(),
                }))
                    .sort((a, b) => a.label.localeCompare(b.label)),
            ]
            : [];
    }
    get royaltiesUsagePeriodOptions() {
        var _a, _b;
        let options = [{ label: 'April 2021', value: '04-2021', id: '1' }];
        const latestDate = (_b = (_a = this._latestRoyaltiesDate) === null || _a === void 0 ? void 0 : _a.latestCompletedDistributionPeriodStartDate) !== null && _b !== void 0 ? _b : '';
        if (latestDate !== '') {
            let timestamp = (0, dayjs_1.default)(latestDate, 'YYYY-MM-DD');
            let idCount = 1;
            while (timestamp.format('MM-YYYY') !== '04-2021') {
                idCount++;
                options.push({
                    label: timestamp.format('MMMM YYYY'),
                    value: timestamp.format('MM-YYYY'),
                    id: idCount.toString(),
                });
                timestamp = timestamp.subtract(1, 'month');
            }
            options = options.sort((a, b) => (0, dayjs_1.default)(b.value, 'MM-YYYY').isBefore((0, dayjs_1.default)(a.value, 'MM-YYYY')) ? -1 : 1);
        }
        return options;
    }
    get payeeOptionsForSelect() {
        var _a;
        const payeeOptionData = (_a = this._payeeOptions) !== null && _a !== void 0 ? _a : [];
        return payeeOptionData
            .slice()
            .map((payee, idx) => ({
            label: payee.name,
            value: payee.ipId.toString(),
            id: (idx + 1).toString(),
        }))
            .sort((a, b) => (a.label < b.label ? -1 : 1));
    }
    get dspOptions() {
        const dspOptions = this._statements
            .map((row) => row.dsp)
            .filter((dsp, idx, arr) => arr.indexOf(dsp) === idx)
            .map((dsp, idx) => ({ label: dsp, value: dsp, id: (idx + 2).toString() }))
            .sort((a, b) => a.label.localeCompare(b.label));
        dspOptions.unshift({ label: 'All', value: 'All', id: '1' });
        return dspOptions;
    }
    get filteredRows() {
        return this._selectedUsagePeriod && this._selectedDsp && this._selectedPayee
            ? this._statements
                .slice()
                .map((statement) => (Object.assign(Object.assign({}, statement), { payee: this._selectedPayee.label })))
                .filter((statement) => (statement.dsp === this._selectedDsp.value || this._selectedDsp.value === 'All') &&
                statement.month.toString().padStart(2, '0') + '-' + statement.year.toString() ===
                    this._selectedUsagePeriod.value)
                .sort((a, b) => a.dsp.localeCompare(b.dsp) || b.year - a.year || b.month - a.month)
            : [];
    }
}
exports.StatementsStore = StatementsStore;
